import i18n from "../../i18n";

export function aa(key, defaultValue, options = {}) {
  return i18n.t(`admin_analytics_${key}`, {
    defaultValue,
    ...options,
  });
}

export function asArray(value) {
  return Array.isArray(value) ? value : [];
}

export function asNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

export function formatNumber(value) {
  return Math.round(asNumber(value)).toLocaleString();
}

export function formatDecimal(value, digits = 1) {
  return asNumber(value).toLocaleString(undefined, {
    maximumFractionDigits: digits,
    minimumFractionDigits: 0,
  });
}

export function formatRate(value) {
  return `${Math.round(asNumber(value) * 100)}%`;
}

export function formatDuration(value) {
  const totalSeconds = Math.round(asNumber(value));
  if (totalSeconds <= 0) return "0s";

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes <= 0) return `${seconds}s`;
  if (seconds <= 0) return `${minutes}m`;
  return `${minutes}m ${seconds}s`;
}

export function formatDay(value) {
  if (!value) return aa("unknown", "Unknown");
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(value) {
  if (!value) return aa("none", "None");
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return aa("none", "None");
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatLabel(value, fallback = aa("unknown", "Unknown")) {
  const text = String(value || "").trim();
  if (!text) return fallback;
  return text
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function getUserLabel(row) {
  const username = String(row?.username || "").trim();
  return username || aa("unknown_user", "Unknown user");
}

export function getUserSubLabel(row) {
  const userId = String(row?.userId || "").trim();
  return userId || aa("no_user_id", "No user id");
}

export function getErrorCopy(error) {
  if (error?.status === 403) {
    return {
      title: aa("access_denied_title", "Access denied"),
      body: aa(
        "access_denied_body",
        "This account does not have access to admin analytics."
      ),
    };
  }

  if (error?.status === 503 || error?.detail === "admin_analytics_unavailable") {
    return {
      title: aa("unavailable_title", "Admin analytics unavailable"),
      body: aa(
        "unavailable_body",
        "Admin analytics is not configured or this dashboard section could not be loaded."
      ),
    };
  }

  return {
    title: aa("load_error_title", "Could not load analytics"),
    body: aa(
      "load_error_body",
      "This dashboard section failed to load. Try again in a moment."
    ),
  };
}

export function hasAnyCount(summary, keys) {
  return keys.some((key) => asNumber(summary?.[key]) > 0);
}

export function pickValue(row, keys) {
  for (const key of keys) {
    if (row?.[key] !== undefined && row?.[key] !== null) {
      return row[key];
    }
  }
  return 0;
}
